import * as React from 'react';
import { classes } from './WeeklyMobileDatesHeader.st.css';
import AddIcon from '@material-ui/icons/Add';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { setOpacity } from '../../../utils/colorUtils';
import WeeklyContextMobile from '../../../context/weeklyContextMobile';
import WixStylesContext from '../../../context/wixStylesContext';
var WeeklyDotsHeader = function (_a) {
    var eventDate = _a.eventDate, isToday = _a.isToday;
    var googleCalendarColors = React.useContext(WixStylesContext).googleCalendarColors;
    var dates = React.useContext(WeeklyContextMobile).dates;
    var opacity = 1;
    return (React.createElement("div", { className: classes.DotsWrapper }, dates[eventDate] && dates[eventDate].length > 3 ? (React.createElement(React.Fragment, null,
        dates[eventDate] &&
            dates[eventDate].slice(0, 2).map(function (event) { return (React.createElement("div", { key: event.id },
                React.createElement(FiberManualRecordIcon, { className: classes.Bullet, htmlColor: isToday
                        ? 'white'
                        : googleCalendarColors
                            ? setOpacity(opacity, event.googleColor)
                            : setOpacity(opacity, event.eventColor) }))); }),
        React.createElement("div", null,
            React.createElement(AddIcon, { style: { fontSize: 5 }, className: classes.Plus, htmlColor: isToday ? 'white' : 'black' })))) : (dates[eventDate] &&
        dates[eventDate].map(function (event) { return (React.createElement("div", { key: event.id },
            React.createElement(FiberManualRecordIcon, { className: classes.Bullet, htmlColor: isToday
                    ? 'white'
                    : googleCalendarColors
                        ? setOpacity(opacity, event.googleColor)
                        : setOpacity(opacity, event.eventColor) }))); }))));
};
export default WeeklyDotsHeader;
//# sourceMappingURL=WeeklyDotsHeader.js.map